
export default function BenefitsSection() {
  const benefits = [
    {
      title: "Professional Development",
      description: "Access continuing education, workshops, and certification programs to advance your career.",
      icon: "ri-graduation-cap-line",
      image: "https://public.readdy.ai/ai/img_res/09aab6ed2c22b45e6521df004195b154.jpg"
    },
    {
      title: "Networking Opportunities", 
      description: "Connect with peers, mentors, and industry leaders through exclusive events and online communities.",
      icon: "ri-team-line",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20networking%20at%20conference%2C%20diverse%20group%20of%20pharmacists%20and%20veterinarians%20in%20professional%20conversation%2C%20modern%20conference%20setting%20with%20clean%20backgrounds&width=400&height=300&seq=benefit2&orientation=landscape"
    },
    {
      title: "Research & Resources",
      description: "Gain access to the latest research, clinical guidelines, and professional tools.",
      icon: "ri-file-text-line", 
      image: "https://readdy.ai/api/search-image?query=Medical%20research%20laboratory%20with%20healthcare%20professionals%20reviewing%20documents%20and%20digital%20resources%2C%20modern%20medical%20library%20setting%20with%20clean%20backgrounds%2C%20professional%20research%20environment&width=400&height=300&seq=benefit3&orientation=landscape"
    },
    {
      title: "Advocacy & Representation",
      description: "Have your voice heard in policy decisions that affect your profession and patients.",
      icon: "ri-megaphone-line",
      image: "https://readdy.ai/api/search-image?query=Professional%20healthcare%20advocacy%20meeting%20with%20diverse%20medical%20professionals%20discussing%20policy%2C%20modern%20conference%20room%20with%20clean%20backgrounds%2C%20healthcare%20leadership%20and%20representation&width=400&height=300&seq=benefit4&orientation=landscape"
    },
    {
      title: "Career Support",
      description: "Access job boards, career counseling, and professional mentorship programs.",
      icon: "ri-briefcase-line",
      image: "https://readdy.ai/api/search-image?query=Professional%20career%20counseling%20session%20with%20healthcare%20mentor%20and%20mentee%2C%20modern%20office%20setting%20with%20clean%20backgrounds%2C%20career%20development%20consultation%20in%20medical%20field&width=400&height=300&seq=benefit5&orientation=landscape"
    },
    {
      title: "Member Discounts",
      description: "Enjoy exclusive discounts on conferences, publications, and professional services.",
      icon: "ri-price-tag-3-line",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20conference%20exhibition%20with%20professional%20medical%20equipment%20and%20educational%20materials%2C%20modern%20trade%20show%20setting%20with%20clean%20backgrounds%2C%20medical%20industry%20showcase%20and%20resources&width=400&height=300&seq=benefit6&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Membership Benefits
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the comprehensive benefits and resources available to CPVA members.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-w-16 aspect-h-9">
                <img 
                  src={benefit.image} 
                  alt={benefit.title}
                  className="w-full h-48 object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${benefit.icon} text-xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
